module.exports = __webpack_public_path__ + "static/media/anticlockwise.fbc3ee8e.svg";